import { makeAutoObservable } from 'mobx';
import ILocation from "../interfaces/ILocation";
import ILocationInfo from '../interfaces/ILocationInfo';
import LocationsApiService from "../services/locationsApiService";

export default class LocationStore {
    isLoading: boolean = false;
    isError: boolean = false;
    locations: ILocation[] = [];
    checkedCompanyIds: number[] = [];
    radiusLocationIds: number[] = [];

    constructor(
        private locationApiService: LocationsApiService,
    ) {
        makeAutoObservable(this);
    }

    setIsLoading(value: boolean) {
        this.isLoading = value;
    }

    setIsError(value: boolean) {
        this.isError = value;
    }

    setLocations(locations: ILocation[]) {
        this.locations = locations;
    }

    setCheckedCompanyIds(value: number[]) {
        this.checkedCompanyIds = value;
    }

    setRadiusLocationIds(value: number[]) {
        this.radiusLocationIds = value;
    }

    initialize() {
        this.fetchLocations();
    }

    async fetchLocations() {
        this.setIsLoading(true);
        try {
            this.setLocations(await this.locationApiService.getLocations());
        } catch {
            this.setIsError(true);
        } finally {
            this.setIsLoading(false);
        }
    }

    async addLocation(location: ILocationInfo): Promise<number> {
        const createdLocation = await this.locationApiService.createLocation(location);
        this.setLocations([
            ...this.locations,
            createdLocation,
        ]);

        return createdLocation.id;
    }

    async addLocations(locationInfos: ILocationInfo[]) {
        await this.locationApiService.createLocations(locationInfos);
        this.fetchLocations();
    }

    async updateLocation(updatedLocation: ILocation) {
        await this.locationApiService.updateLocation(updatedLocation);
        this.setLocations([
            ...this.locations.filter(l => l.id !== updatedLocation.id),
            updatedLocation,
        ]);
    }

    async deleteLocation(id: number) {
        await this.locationApiService.deleteLocation(id);
        this.setLocations(this.locations.filter(l => l.id !== id));
    }

    async deleteLocations(ids: number[]) {
        await this.locationApiService.deleteLocations(ids);
        this.setLocations(this.locations.filter(l => !ids.includes(l.id)));
    }

    clear() {
        this.setIsLoading(false);
        this.setIsError(false);
        this.setLocations([]);
    }
}